<template>
  <div class="BookcaseIndex">
    <template v-if="$route.name === 'BookcaseIndex'">
      <div class="titleArea">
        <img class="logo" :src="companyInfo.logo_url" alt="">
        <p class="title">{{companyInfo.company_name}}</p>
      </div>
      <img class="knowledge" src="/static/Bookcase/images/knowledge.png" alt="">
      <div class="bbtnArea">
        <p class="bbtn bbtn-y" @click="go('buy')">我要买书</p>
        <p class="bbtn bbtn-p" @click="go('sell')">我要卖书</p>
      </div>
    </template>
    <template v-else>
      <div class="BookcaseNavBar">
        <span class="back" @click="back"></span>
        <span class="title">扫码登录</span>
      </div>
      <div class="Login">
        <img class="code" :src="codeUrl" alt="">
        <p class="text">请扫码进行登录</p>
        <p class="hint">未注册用户？<span class="color" @click="goRegister">点此注册</span></p>
      </div>
      <!-- mqtt -->
      <mqttws ref="mqttws" :topic="topic" @getMessage="getMessage"></mqttws>
    </template>
  </div>
</template>

<script>
import * as config from '../../../../static/js/config.js'
import { storage, messageError } from '../../../../static/js/utils/utility'
import { ECMallApi } from '../../../../static/Bookcase/js/api'
 import mqttws from './Mqttws'
//import mqttws from '../../../assets/mqttws2'
let vm

export default {
  name:'BookcaseIndex',
  components: {
    mqttws
  },
  data() {
    return {
      topic: '/' + config.serverPort2 + '/login/' + config.deviceId + '/control/protocol',
      // topic: '/47.106.146.148/login/' + config.deviceId + '/control/protocol',
      companyInfo: {},
      codeUrl: ''
    }
  },
  created() {
    vm = this
    // console.log('this', this.$route)
    vm.init(vm.$route.name)
  },
  mounted () {
  },
  methods: {
    // 获取公司信息
    async getCompanyInfo () {
      let data = {
        cabinet_id: config.deviceId
      }

      let res = await ECMallApi.getCompanyInfo(data)
      if (res.meta.code === 200) {
        vm.companyInfo = res.data
        vm.companyInfo.logo_url = res.data.logo_url === '' ? '/static/images/logo.png' : res.data.logo_url
        vm.$store.state.ECMall_companyInfo = vm.companyInfo
      } else {
        messageError(res.meta.message)
      }
    },
    // 获取小程序码
    async getQrcode () {
      let data = {
        data:{
          "page": "pages/login/login",
          "scene": vm.companyInfo.company_ic + 'my' + config.deviceId
        },
        mode: "getUnlimited",
        type: "my",
        device_no_id: config.deviceId
      }

      let res = await ECMallApi.getQrcode(data)
      if (res.meta.code === 200) {
        vm.codeUrl = res.data.image_url
      } else {
        messageError(res.meta.message)        
      }
    },
    // 获取mqtt的返回信息
    getMessage (res) {
      console.log(res)
      if (res.meta.code === 200) {
        vm.$store.state.eUserInfo = res.data
        let type = vm.$store.state.type
        let path = type === 'buy' ? '/Bookcase/MyReserve' : '/Bookcase/MySell'
        vm.$router.push(path)
      } else {
        messageError(res.meta.message)
      }
    },
    // 返回
    back () {
      vm.$router.go(-1)
    },
    // 买书/卖书
    go (type) {
      vm.$store.state.type = type
      vm.$router.push('/Bookcase/Login')
    },
    // 去注册
    goRegister () {
      vm.$router.push({
        path: '/Bookcase/Register'
      })
    },
    // 页面初始加载
    init (name) {
      if (name === 'BookcaseIndex') {
        vm.getCompanyInfo()
      } else {
        vm.companyInfo = vm.$store.state.ECMall_companyInfo
        vm.getQrcode()
      }
    }
  },
  watch: {
    '$route.name' (newVal) {
      this.init(newVal)
    }
  },
}
</script>

<style lang="less">
.Bookcase{
  .BookcaseIndex {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    // 首页
    .titleArea {
      width: 100%;
      padding: 0.38rem 0 0 0.27rem;
      display: flex;
      align-items: center;
      .logo {
        width: 0.91rem;
        // height: 0.8rem;
        margin-right: 0.15rem;
      }
      .title {
        font-size: 0.4rem;
        font-weight: bold;
        color: #333333;
      }
    }
    .knowledge {
      display: block;
      width: 5.41rem;
      height: 4.43rem;
      margin: 1.7rem auto 0.65rem;
    }
    .bbtnArea {
      display: flex;
      flex-direction: column;
      align-items: center;
      .bbtn {
        width: 7.7rem;
        font-size: 0.38rem;
        font-weight: bold;
        &+.bbtn {
          margin-top: 0.66rem;
        }
      }
    }
    // 登录
    .Login {
      display: flex;
      flex-direction: column;
      align-items: center;
      .code {
        width: 4.68rem;
        height: 4.68rem;
        margin: 2.55rem 0 0.46rem;
      }
      .text {
        color: #647de6;
        font-weight: bold;
        font-size: 0.58rem;
      }
      .hint {
        font-size: 0.36rem;
        line-height: 1;
        margin-top: 0.28rem;
        color: #333333;
        .color {
          color: #647de6;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bookcase/Common/Index.vue